import React from 'react';

export const SoundLogoV2 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1966_83540)">
        <rect width="48" height="48" fill="#0E1213" />
        <rect width="49.1651" height="49.1651" fill="#0E1213" />
        <g clipPath="url(#clip1_1966_83540)">
          <path
            d="M35.52 21.942C35.784 21.942 36 21.726 36 21.462V15.942C36 15.678 35.784 15.462 35.52 15.462H33.6C33.336 15.462 33.12 15.246 33.12 14.982V13.062C33.12 12.798 32.904 12.582 32.64 12.582H15.36C15.096 12.582 14.88 12.798 14.88 13.062V14.982C14.88 15.246 14.664 15.462 14.4 15.462H12.48C12.216 15.462 12 15.678 12 15.942V23.862C12 24.126 12.216 24.342 12.48 24.342H18.72C18.984 24.342 19.2 24.558 19.2 24.822V26.262C19.2 26.526 19.416 26.742 19.68 26.742H28.32C28.584 26.742 28.8 26.958 28.8 27.222V32.262C28.8 32.526 28.584 32.742 28.32 32.742H23.28C23.016 32.742 22.8 32.526 22.8 32.262V30.102C22.8 29.838 22.584 29.622 22.32 29.622H17.28C17.016 29.622 16.8 29.406 16.8 29.142V27.702C16.8 27.438 16.584 27.222 16.32 27.222H12.48C12.216 27.222 12 27.438 12 27.702V33.222C12 33.486 12.216 33.702 12.48 33.702H14.4C14.664 33.702 14.88 33.918 14.88 34.182V36.102C14.88 36.366 15.096 36.582 15.36 36.582H32.64C32.904 36.582 33.12 36.366 33.12 36.102V34.182C33.12 33.918 33.336 33.702 33.6 33.702H35.52C35.784 33.702 36 33.486 36 33.222V25.302C36 25.038 35.784 24.822 35.52 24.822H29.28C29.016 24.822 28.8 24.606 28.8 24.342V22.902C28.8 22.638 28.584 22.422 28.32 22.422H19.68C19.416 22.422 19.2 22.206 19.2 21.942V16.902C19.2 16.638 19.416 16.422 19.68 16.422H24.72C24.984 16.422 25.2 16.638 25.2 16.902V19.062C25.2 19.326 25.416 19.542 25.68 19.542H30.72C30.984 19.542 31.2 19.758 31.2 20.022V21.462C31.2 21.726 31.416 21.942 31.68 21.942H35.52Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1966_83540">
          <rect width="48" height="48" rx="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_1966_83540">
          <rect width="24" height="24" fill="white" transform="translate(12 12.583)" />
        </clipPath>
      </defs>
    </svg>
  );
};
